<app-activity-table entityType="task" [entityId]="taskId">
  <app-empty-table type="ActivityList"></app-empty-table>
</app-activity-table>
